import { AxiosResponse } from 'axios';
import { DocumentCitizenshipFormVM } from 'civil-status/view-models/document-birth-form';
import { DateTime } from 'luxon';
import { DocumentCitizenshipCM } from 'shell/models/document-citizenship';
import { HttpResponse } from 'shell/models/http-response';

export const transformCitizenshipDocument = (
  response: AxiosResponse<HttpResponse<DocumentCitizenshipCM>>
): DocumentCitizenshipFormVM => {
  const payloadResponse = response.data?.payload;

  const item: DocumentCitizenshipFormVM = {
    indicatorUpdate:
      payloadResponse?.datiAttoCittadinanza?.indicatoreAggiornamento === '0' ||
      !payloadResponse?.datiAttoCittadinanza?.indicatoreAggiornamento
        ? 'È necessario effettuare la convalida dei dati.'
        : '',
    matricola: payloadResponse?.datiAttoCittadinanza?.matricola?.toString() || '',
    surname:
      payloadResponse?.datiAttoCittadinanza?.cognome ||
      payloadResponse.datiAttoCittadinanza.key?.cognome ||
      '',
    name:
      payloadResponse?.datiAttoCittadinanza?.nome ||
      payloadResponse.datiAttoCittadinanza?.key?.nome ||
      '',
    gender: payloadResponse?.datiAttoCittadinanza?.sesso || '',
    // municipalityBirth: payloadResponse?.datiAttoCittadinanza?.comuneNascita || '',
    residenceMunicipality: payloadResponse?.datiAttoCittadinanza?.comuneResidenza || '',
    citizenshipDate: payloadResponse?.datiAttoCittadinanza?.dataCittadinanza
      ? DateTime.fromISO(payloadResponse?.datiAttoCittadinanza?.dataCittadinanza)
      : null,
    birthdayMunicipality: payloadResponse?.datiAttoCittadinanza?.comuneNascita || '',
    surnameFather: payloadResponse?.datiAttoCittadinanza?.cognomePadre || '',
    nameFather: payloadResponse?.datiAttoCittadinanza?.nomePadre || '',
    surnameMother: payloadResponse?.datiAttoCittadinanza?.cognomeMadre || '',
    nameMother: payloadResponse?.datiAttoCittadinanza?.nomeMadre || '',
    time: payloadResponse?.datiAttoCittadinanza?.oraNascita
      ? DateTime.fromISO(payloadResponse?.datiAttoCittadinanza?.oraNascita)
      : null,
    birthday: payloadResponse?.datiAttoCittadinanza?.dataNascita
      ? DateTime.fromISO(payloadResponse?.datiAttoCittadinanza?.dataNascita)
      : null,
    year: payloadResponse?.datiAttoCittadinanza?.key?.anno || '',
    registerNumber: payloadResponse?.datiAttoCittadinanza?.key?.numeroRegistro || '',
    documentNumber: payloadResponse?.datiAttoCittadinanza?.key?.numeroAtto?.toString() || '',
    portion: payloadResponse?.datiAttoCittadinanza?.key?.parte || '',
    serie: payloadResponse?.datiAttoCittadinanza?.key?.serie1?.trim() || '',
    serie2: payloadResponse?.datiAttoCittadinanza?.key?.serie2?.trim() || '',
    uploadFile:
      payloadResponse?.attoCittadinanzaCM?.attoByteArray &&
      payloadResponse?.attoCittadinanzaCM?.atto
        ? {
            raw:
              payloadResponse?.attoCittadinanzaCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
            rawTiff: `data:image/png;base64,${payloadResponse?.attoCittadinanzaCM?.attoByteArray}`,
            file: new File(
              payloadResponse?.attoCittadinanzaCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
              payloadResponse?.attoCittadinanzaCM?.nomeFile
            ),
          }
        : undefined,
    annotationInternationalList:
      payloadResponse?.annotazioniAttoCittadinanzaInt?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
    annotationNationalList:
      payloadResponse?.annotazioniAttoCittadinanzaNaz?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
  };
  return item;
};

export const transformCitizenshipRequest = (values: DocumentCitizenshipFormVM) =>
  ({
    key: {
      numeroAtto: values.documentNumber || undefined,
      numeroRegistro: values.registerNumber || undefined,
      parte: values.portion || undefined,
      serie1: values.serie || undefined,
      serie2: values.serie2 || ' ',
      anno: values.year || undefined,
      cognome: values.surname || undefined,
      nome: values.name || undefined,
    },
    matricola: values.matricola || undefined,
    dataNascita: values.birthday ? values.birthday?.toFormat('yyyy-MM-dd') : undefined,
    oraNascita: values.time || undefined,
    sesso: values.gender || undefined,
    comuneNascita: values.birthdayMunicipality || values.municipalityBirth || undefined,
    comuneResidenza: values.residenceMunicipality || undefined,
    dataCittadinanza: values.citizenshipDate || undefined,
    // indirizzoNascita: values.
    cognomePadre: values.surnameFather || undefined,
    nomePadre: values.nameFather || undefined,
    cognomeMadre: values.surnameMother || undefined,
    nomeMadre: values.nameMother || undefined,
  } as const);
